/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Extra_Units_Not_On_HoldInputs */

const en_error_extra_units_not_on_hold = /** @type {(inputs: Error_Extra_Units_Not_On_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This inbound holds no units to release: it is not an inbound of extra units, or it was already sent to Business Central or released.`)
};

/**
* | output |
* | --- |
* | "This inbound holds no units to release: it is not an inbound of extra units, or it was already sent to Business Central or released." |
*
* @param {Error_Extra_Units_Not_On_HoldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_extra_units_not_on_hold = /** @type {((inputs?: Error_Extra_Units_Not_On_HoldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Extra_Units_Not_On_HoldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_extra_units_not_on_hold(inputs)
});